/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_Slug_HintInputs */

const vi_shop_home_link_slug_hint = /** @type {(inputs: Shop_Home_Link_Slug_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn bài viết/trang trên web, vd gioi-thieu`)
};

/**

* @param {Shop_Home_Link_Slug_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_slug_hint = /** @type {((inputs?: Shop_Home_Link_Slug_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_Slug_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_slug_hint(inputs)
});